// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c604bcef","453":"cdd486f8","667":"a5922ec3","919":"eb8b01b2"}[chunkId] + ".chunk.js";
};